import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { centers } from '../data/siteContent';

const CenterDetail = () => {
  const { id } = useParams();
  const center = centers.find((item) => item.id === Number(id));

  if (!center) {
    return (
      <div className="center-not-found">
        <TopBar />
        <Navbar />
        <div className="container">
          <h2>Center not found</h2>
          <Link to="/our-centers" className="back-button">Back to Centers</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="center-detail-page">
      <TopBar />
      <Navbar />

      <section className="center-hero">
        <div className="hero-image">
          <img src={center.image} alt={center.name} />
        </div>
        <div className="hero-overlay">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>{center.name}</h1>
            <p>{center.city}</p>
          </motion.div>
        </div>
      </section>

      <section className="center-details">
        <div className="container">
          <div className="details-grid">
            <motion.div
              className="detail-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h3><i className="fas fa-map-marker-alt"></i> Address</h3>
              <p>{center.address}</p>
              <p>{center.note}</p>
            </motion.div>

            <motion.div
              className="detail-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h3><i className="fas fa-phone-alt"></i> Contact</h3>
              <p>{center.phone}</p>
              <p>Appointment support available in Hindi.</p>
            </motion.div>

            <motion.div
              className="detail-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h3><i className="fas fa-clock"></i> Timings</h3>
              <p>Mon - Sat: 9:00 AM - 6:00 PM</p>
              <p>Please confirm your visit slot before arrival.</p>
            </motion.div>
          </div>

          <motion.div
            className="navigation-section"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <h2>Get Directions</h2>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(center.address)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="direction-button"
            >
              <i className="fas fa-directions"></i> Open in Google Maps
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CenterDetail;
